import {
  initializeFaro,
  getWebInstrumentations,
  FetchTransport,
  TransportItemType,
} from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export const initFaro = () => {
  const faroUrl = import.meta.env.VITE_FARO_PATH;
  if (!faroUrl || faroUrl.startsWith('__')) return;

  // 동일 메시지가 짧은 시간에 폭주하는 것을 막는다. 모니터링 그리드에서 카메라 WebRTC
  // 재연결 루프나 1초 주기 frame-stall 로그가 captureConsole로 전부 이벤트화되면
  // 트랜스포트 버퍼(기본 30)가 넘쳐 'Task buffer full' / 'Failed to fetch'가 폭주한다.
  // 윈도우 내 첫 건만 보내고 중복은 버린다(에러 신호 자체는 보존). trace는 항상 통과.
  const lastSeen = new Map<string, number>();
  const DEDUPE_MS = 5000;

  initializeFaro({
    ignoreUrls: [new RegExp(faroUrl)],
    app: {
      name: 'macs-frontend-svelte',
      version: '1.0.0',
    },
    // 더 적은 수의 큰 배치로 전송해 HTTP/1.1 커넥션 풀 경쟁을 줄인다.
    batching: {
      enabled: true,
      sendTimeout: 2000,
      itemLimit: 100,
    },
    // 명시적 트랜스포트: 버퍼를 키우고 keepalive를 켜 언로드/버스트에도 전송이
    // 끊기지 않게 한다. (Faro는 페이로드가 ~60KB를 넘으면 keepalive를 자동 비활성한다)
    transports: [
      new FetchTransport({
        url: faroUrl,
        bufferSize: 60,
        requestOptions: {
          keepalive: true,
        },
      }),
    ],
    beforeSend: (item) => {
      if (item.type === TransportItemType.TRACE) return item;

      const payload = item.payload as unknown as {
        message?: string;
        value?: string;
        name?: string;
      };
      const key = `${item.type}:${payload?.message ?? payload?.value ?? payload?.name ?? ''}`;
      const now = Date.now();
      const previous = lastSeen.get(key);
      if (previous !== undefined && now - previous < DEDUPE_MS) {
        return null;
      }

      // 키 카디널리티가 무한정 커지는 것을 방지(메모리 가드).
      if (lastSeen.size > 1000) lastSeen.clear();
      lastSeen.set(key, now);
      return item;
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new TracingInstrumentation(),
    ],
  });
};
